import { Box, ColoredDot, Flex } from 'styling/GlobalStyles'
import { BodyText, Head2, OtherText, TitleText } from 'styling/Typography'
import { AccommodationNotificationContainer, AvailabilityIndicator, Block, BlockContainer, BlockStatusesContainer, CampContainer, CampOverviewContainer, ColoredSquare } from '../Accommodation.style'
import { ExclamationMarkIcon } from '../icons/ExclamationMarkIcon'
import { useState } from 'react'
import Chevron from 'assets/icons/Chevron'
import { WarningIcon } from '../icons/WarningIcon'

export const AccomodationDashboard = () => {
    const StatusCard = ({ name, count, color }) => {
        return <Box height='105px' width='100%' style={{ borderTop: '1px solid #ff9900', borderRadius: '12px', padding: '1rem' }} >
            <Flex width='100%' height='100%' column between >
                <Flex center gap='1rem' >
                    <ColoredDot color={color || '#ff9900'} />
                    <TitleText weight='bold' >{name || 'AVAILABLE'}</TitleText>
                </Flex>
                <Flex width='100%' justend ><BodyText style={{ fontSize: 30 }} >{count || 0}</BodyText></Flex>
            </Flex>
        </Box>
    }

    const Notification = ({ type, title, description, time }) => {
        return <AccommodationNotificationContainer>
            <Flex gap='1rem' center>
                <ExclamationMarkIcon />
                <Flex column gap='0.5rem' >
                    <BodyText>{title || 'Capacity exceeded in North Camp Block A'}</BodyText>
                    <OtherText grey >{description || 'The number of occupants in North Camp Block A has exceeded the maximum capacity.'}</OtherText>
                </Flex>
            </Flex>
            <OtherText grey >{time || '5mins ago'}</OtherText>
        </AccommodationNotificationContainer>
    }

    const CampSection = () => {
        const [active, setActive] = useState(false)
        return <CampContainer active={active} onClick={() => setActive(!active)} >
            <CampOverviewContainer>
                <Flex column between height='100%'>
                    <BodyText style={{ fontSize: 20 }} >North Camp</BodyText>
                    <BodyText grey >2 blocks · 8 rooms · 20 beds total</BodyText>
                </Flex>
                <Flex height='100%' gap='1rem' center >
                    <Flex center column height='100%' between >
                        <Head2 color={colors.occupied} >15%</Head2>
                        <BodyText grey >Occupancy</BodyText>
                    </Flex>

                    <Flex center column height='100%' between >
                        <Head2 color={colors.available} >10</Head2>
                        <BodyText grey >Available</BodyText>
                    </Flex>

                    <Flex center column height='100%' between >
                        <Head2 color={colors.dirty} >10</Head2>
                        <BodyText grey >Need Cleaning</BodyText>
                    </Flex>

                    <Chevron open={active} />
                </Flex>
            </CampOverviewContainer>.
            <BlockContainer>
                <SingleBlock />
                <SingleBlock />
                <SingleBlock />
                <SingleBlock />
            </BlockContainer>
        </CampContainer>
    }

    const SingleBlock = () => {
        return <Block>
            <Flex width='100%' between >
                <Flex column gap='0.5rem' height='100%' between>
                    <Flex gap='0.5rem' ><TitleText style={{ fontSize: 18 }} >Block A</TitleText><WarningIcon /></Flex>
                    <BodyText grey >4 rooms · 12 beds total</BodyText>
                </Flex>
                <BodyText weight='bold' style={{ fontSize: 20, color: colors.available }} >25%</BodyText>



            </Flex>
            <Flex mt='16' mb='16' gap='0.5rem' column >
                <Flex width='100%' between >
                    <OtherText grey >Availability</OtherText>
                    <OtherText grey >4 / 12</OtherText>
                </Flex>
                <AvailabilityIndicator color={colors.available} percentage={25} />
            </Flex>
            <BlockStatusesContainer>
                <BlockStatus name='Available' count={4} color={colors.available} />
                <BlockStatus name='Occupied' count={8} color={colors.occupied} />
                <BlockStatus name='Dirty' count={0} color={colors.dirty} />
                <BlockStatus name='Blocked' count={0} color={colors.blocked} />
            </BlockStatusesContainer>
        </Block>
    }

    const BlockStatus = ({ name, count, color }) => {
        return <Flex height='40px' width='100%' gap='0.5rem' center >

            <ColoredSquare color={color || '#ff9900'} />
            <Flex column between >
                <TitleText  >{count}</TitleText>
                <BodyText grey >{name} </BodyText>
            </Flex>
        </Flex>
    }

    return <>
        <Flex mt='16' mb='16' gap='1rem' >
            <StatusCard name='TOTAL CAPACITY' color={colors.totalCapacity} count={10} />
            <StatusCard name='AVAILABLE' color={colors.available} count={5} />
            <StatusCard name='OCCUPIED' color={colors.occupied} count={3} />
            <StatusCard name='DIRTY' color={colors.dirty} count={2} />
            <StatusCard name='BLOCKED' color={colors.blocked} count={2} />
        </Flex>
        <Box>
            <Flex column gap='1rem' >
                <Notification type='warning' title='Capacity exceeded in North Camp Block A' description='The number of occupants in North Camp Block A has exceeded the maximum capacity.' time='5 mins ago' />
                <Notification type='warning' title='Capacity exceeded in South Camp Block B' description='The number of occupants in South Camp Block B has exceeded the maximum capacity.' time='10 mins ago' />
            </Flex>
        </Box>
        <Box style={{ marginTop: '1rem' }} >
            <Flex column gap='1rem'>
                <BodyText style={{ fontSize: 20 }} >Camps</BodyText>
                <CampSection />
                <CampSection />
                <CampSection />
            </Flex>
        </Box>
    </>
}
const colors = {
    totalCapacity: '#ff9800',
    available: '#10B981',
    occupied: '#51A2FF',
    dirty: '#F4D03F',
    blocked: '#FF6467',
}